import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';
import { moduleSelectionGuard } from '@core/guards/module-selection.guard';
import { permissionGuard } from '@core/guards/permission.guard';
import { superAdminGuard } from '@core/guards/super-admin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app',
  },
  {
    path: 'login',
    title: 'Entrar | NEXO',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('@layouts/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@features/auth/login/login-page.component').then((m) => m.LoginPageComponent),
      },
    ],
  },
  {
    path: 'selecionar-modulo',
    title: 'Selecionar módulo | NEXO',
    canActivate: [authGuard, moduleSelectionGuard],
    loadComponent: () =>
      import('@features/module-selection/module-selection-page.component').then(
        (m) => m.ModuleSelectionPageComponent,
      ),
  },
  {
    path: 'vendas',
    title: 'Vendas | NEXO',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@features/sales/sales-module-page.component').then((m) => m.SalesModulePageComponent),
  },
  {
    path: 'app',
    title: 'Início',
    canActivate: [authGuard, superAdminGuard, permissionGuard],
    canActivateChild: [superAdminGuard],
    loadComponent: () =>
      import('@layouts/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
    data: {
      title: 'Início',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'usuarios/novo',
      },
      {
        path: 'usuarios/novo',
        title: 'Novo cadastro',
        loadComponent: () =>
          import('@features/users/user-registration/user-registration-page.component').then(
            (m) => m.UserRegistrationPageComponent,
          ),
        data: {
          title: 'Novo cadastro',
        },
      },
      {
        path: 'inicio',
        title: 'Página inicial | NEXO',
        loadComponent: () =>
          import('@features/placeholder-page.component').then((m) => m.PlaceholderPageComponent),
        data: {
          title: 'Página inicial',
          description: 'Os indicadores do CRM serão exibidos nesta área.',
        },
      },
      {
        path: 'empresa',
        pathMatch: 'full',
        redirectTo: 'empresa/unidades',
      },
      {
        path: 'empresa/unidades',
        title: 'Empresa | NEXO',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@features/unidades/unidades-page.component').then((m) => m.UnidadesPageComponent),
        data: {
          title: 'Empresa',
          permission: 'unidade.visualizar',
        },
      },
      {
        path: 'empresa/unidades/novo',
        title: 'Cadastrar unidade | NEXO',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@features/unidades/unidade-form-page.component').then(
            (m) => m.UnidadeFormPageComponent,
          ),
        data: {
          title: 'Cadastrar unidade',
          permission: 'unidade.criar',
        },
      },
      {
        path: 'empresa/unidades/:id/editar',
        title: 'Editar unidade | NEXO',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@features/unidades/unidade-form-page.component').then(
            (m) => m.UnidadeFormPageComponent,
          ),
        data: {
          title: 'Editar unidade',
          permission: 'unidade.editar',
        },
      },
      {
        path: 'usuarios/convite',
        title: 'Novo Convite | NEXO',
        loadComponent: () =>
          import('@features/placeholder-page.component').then((m) => m.PlaceholderPageComponent),
        data: {
          title: 'Novo Convite',
          description: 'O fluxo de convite de usuários será conectado nesta seção.',
        },
      },
      {
        path: 'usuarios/gerenciar',
        title: 'Gerenciar Usuários | NEXO',
        loadComponent: () =>
          import('@features/placeholder-page.component').then((m) => m.PlaceholderPageComponent),
        data: {
          title: 'Gerenciar Usuários',
          description: 'A listagem e edição de usuários ficará disponível nesta área.',
        },
      },
      {
        path: 'permissoes',
        title: 'Permissões | NEXO',
        loadComponent: () =>
          import('@features/placeholder-page.component').then((m) => m.PlaceholderPageComponent),
        data: {
          title: 'Permissões',
          description: 'Perfis de acesso e regras de permissão serão configurados aqui.',
        },
      },
      {
        path: 'planos',
        title: 'Planos | NEXO',
        loadComponent: () =>
          import('@features/placeholder-page.component').then((m) => m.PlaceholderPageComponent),
        data: {
          title: 'Planos',
          description: 'A gestão dos planos comerciais ficará disponível nesta seção.',
        },
      },
    ],
  },
  {
    path: '**',
    title: 'Página não encontrada | NEXO',
    loadComponent: () =>
      import('@features/not-found-page.component').then((m) => m.NotFoundPageComponent),
  },
];
